/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AccountNav_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"AccountNavContent_viewer">;
    readonly " $refType": "AccountNav_viewer";
};
export type AccountNav_viewer$data = AccountNav_viewer;
export type AccountNav_viewer$key = {
    readonly " $data"?: AccountNav_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"AccountNav_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "AccountNav_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isClient",
      "selections": [
        {
          "kind": "Defer",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "AccountNavContent_viewer",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '455a7ca665ae3fdc818a7437bf790b32';
export default node;
